const mapCapCoin = coin => ({
  __typename: 'CapCoin',
  id: coin.id,
  name: coin.name,
  symbol: coin.symbol,
  rank: coin.rank || '',
  priceUsd: coin.price_usd || '',
  priceBtc: coin.price_btc || '',
  volumeUsd24: coin['24h_volume_usd'] || '',
  marketCapUsd: coin.market_cap_usd || '',
  availableSupply: coin.available_supply || '',
  totalSupply: coin.total_supply || '',
  maxSupply: coin.max_supply || '',
  percentChange1h: coin.percent_change_1h || '',
  percentChange24h: coin.percent_change_24h || '',
  percentChange7d: coin.percent_change_7d || '',
  lastUpdated: coin.last_updated || '',
});

export default mapCapCoin;



// WEBPACK FOOTER //
// ./src/utils/mapCapCoin.js